var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contactus-container"},[_c('module1'),_c('module2')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }